import { lazy } from 'react';

const DashboardRoutes = [
  {
    path: "/dashboard-details",
    component: lazy(() => import("../views/pages/dashboardDetails")),
    exact: true,
  },
  {
    path: "/home",
    component: lazy(() => import("../views/pages/chart-dashboard-modules/dashboard-view")),
    // component: lazy(() => import("../views/pages/chart-dashboard-modules/dashboard-list")),
    exact: true,
    // meta: {
    //   authRoute: true,
    //   id: "acb89131-49e3-4365-baf2-dc0662bc312d",
    // },
  },
];

export default DashboardRoutes;
